import "./blog-page.scss";

(function () {
    if (document.querySelectorAll(".js-blog-page").length > 0) {

        const blogPage = {
            init: function () {
                this.toggleAnchors();
                this.leadFormMobile();
            },
            toggleAnchors: () => {
                const button = document.querySelector(".js-blog-anchors-toggle");
                const list = document.querySelector(".js-blog-anchorlist");

                if (list !== null && button !== null) {
                    const showLessLabel = button.getAttribute("data-expanded-label");
                    const showMoreLabel = button.getAttribute("data-collapsed-label");

                    button.addEventListener("click", () => {
                        if (list.classList.contains("expandable")) {
                            list.classList.remove("expandable");

                            button.textContent = showLessLabel
                        }
                        else {
                            list.classList.add("expandable");

                            button.textContent = showMoreLabel
                        }
                    })
                }
            },
            leadFormMobile: () => {
                const leadForm = document.querySelector("aside .blog-form");
                const leadFormPlaceholder = document.querySelector(".blog-form-placeholder-mobile");

                if (document.documentElement.clientWidth < 800 && leadForm && leadFormPlaceholder) {
                    leadFormPlaceholder.innerHTML = leadForm.innerHTML;
                    leadFormPlaceholder.style.display = "block";
                    leadForm.innerHTML = '';
                }
            },
        };

        blogPage.init();
    }
})();
